import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cIf from 'classnames';

var tr = require('ts-translate-js').default.boundTR;
class UserPhoneNumbers extends Component {
    constructor(props) {
        super(props);
    }

    handleOnPhoneEveningChange(e) {
        this.props.handleOnPhoneNumbersChange({
            homePhone: e.target.value
        });
    }

    handleOnPhoneDayChange(e) {
        this.props.handleOnPhoneNumbersChange({
            PhoneDay: e.target.value
        });
    }

    render() {
        var phoneDay = this.props.showBothPhoneNumbers ? 
            <div className={cIf({ "has-error": (this.props.phoneDayErrorMessage != null) && this.props.showProfileEditionError, "form-group": true })}>
                <label htmlFor="inputPhoneDay" className="control-label">{tr("profileinfo.phone1")}</label><span> <em>{tr("profileedition.optional")}</em></span>
                <input type="text" id="inputPhoneDay" value={this.props.phoneDay} className="form-control" maxLength={20} onChange={(e) => this.handleOnPhoneDayChange(e)}></input>
                {this.props.phoneDayErrorMessage}
            </div> : null;

        return (
            <div>
                <div className={cIf({ "has-error": (this.props.phoneEvening == "" || this.props.phoneEveningErrorMessage != null) && this.props.showProfileEditionError, "form-group": true })}>
                    <label htmlFor="inputPhoneEvening" className="control-label">{this.props.showBothPhoneNumbers ? tr("profileinfo.phone2") : tr("Téléphone")}</label>
                    <input type="text" id="inputPhoneEvening" value={this.props.phoneEvening} className="form-control" maxLength={20} onChange={(e) => this.handleOnPhoneEveningChange(e)}></input>
                    {this.props.phoneEveningErrorMessage}
                </div>
            
                {phoneDay}
                
            </div>
        )
    }
}

UserPhoneNumbers.propTypes = {
    phoneEvening: PropTypes.string,
    phoneDay: PropTypes.string,
    showProfileEditionError: PropTypes.bool,
    showBothPhoneNumbers: PropTypes.bool,
    phoneEveningErrorMessage: PropTypes.string,
    phoneDayErrorMessage: PropTypes.string,
    handleOnPhoneNumbersChange: PropTypes.func
};

export default UserPhoneNumbers;
